import {Badge} from '@sollapay/ui/components';
import {formatReferenceCode} from '@sollapay/utils';

import {CopyButton} from '../CopyButton';

export interface ReferenceCodeBadgeProps {
  code: string;
  fieldName?: string;
  ns?: string;
}

export const ReferenceCodeBadge = ({code, fieldName, ns = 'common'}: ReferenceCodeBadgeProps) => {
  const formatted = formatReferenceCode(code);

  return (
    <Badge variant="outline" size="xs" dir="ltr" className="rounded-md font-mono gap-0.5 pe-2">
      <CopyButton text={formatted} fieldName={fieldName} ns={ns} />
      <span className="translate-y-px leading-none">{formatted}</span>
    </Badge>
  );
};
